import Footer from '../../components/Footer';
import Gnb from '../../components/Gnb';
import AsteroidsContainer from '../../components/Asteroids';

export default function Asteroids() {
  return (
    <>
      <Gnb />
      <AsteroidsContainer />
      <Footer />
    </>
  );
}
